export enum StatusActionEnum {
  ACTIVATE = 'ACTIVATE',
  RESTORE = 'RESTORE',
  RETIRE = 'RETIRE',
}
